import React from "react";
import KpiTicketAnalyticsView from "./KpiTicketAnalyticsView";
import useKpiTicketAnalytics from "./useKpiTicketAnalytics";

function KpiTicketAnalytics(props) {
  return <KpiTicketAnalyticsView {...useKpiTicketAnalytics(props)} />;
}

export default KpiTicketAnalytics;
